import { AcuityAppointmentModel, ProductNameType, StripeProductModel } from "graphql/generated";
import { getAcuityData } from "src/utils";

export const useFilterFCoachProducts = (
  products: StripeProductModel[],
  acuityAppointments: AcuityAppointmentModel[]
) => {
  const acuity = acuityAppointments?.[0];
  const { isFuture } = getAcuityData(acuity);

  products =
    acuity && isFuture
      ? products.filter((item) => item?.uniqName !== ProductNameType.FertilityCoach)
      : products;

  return { products };
};
